import React from 'react'

import SEO from '~/components/seo'
import Cart from '~/components/Cart'
import { Container } from '~/utils/styles'

const CartPage = () => (
  <>
    <SEO title="Cart" />
    <Container>
      <Cart />
    </Container>
  </>
)

export default CartPage
